import z from 'zod';

export const optionalIntegerQueryParamSchema = z.preprocess((value) => {
  if (value === '' || value == null) return undefined;
  if (typeof value === 'string') return Number.parseInt(value, 10);
  return value;
}, z.number().int().positive().optional());
